<template>
  <v-dialog v-model="dialog"
            persistent
            max-width="450px"
            @keydown.esc="closeDialog"
  >
  <v-card id="bookmarkMeeting">
    <!-- layer_popWrap -->
    <div class="bt_wrap member_list" style="min-width: 450px; width: 450px;">
      <div class="popup_top">
        <button class="bt_close" @click="closeDialog">닫기</button>
        <span class="s_title">서울특별시 영상회의 시스템</span>
        <p><span class="b_title">영상장비 수동 연결</span></p>
      </div>
      <div class="dataTable" style="padding-bottom: 5px; min-height: 200px">
        <div class="popup_tel_wrap" style="min-width: 400px; width: 400px;">
          <div class="list" style="width: 100%">
            <span class="list_title">초대된 영상장비 목록 입니다.</span>
            <table style="border-top: 2px solid #8fbfd7; margin-top: 10px;">
              <tr 
                v-for="(listItem, index) in deviceList"
                :key="index">
                <td :class="{ activeTarget: listItem.bindActive }" style="width: 150px; padding-top:13px; padding-left:0; cursor:pointer; text-align:center;">
                  {{listItem.deviceName}}
                </td>
                <td style="width: 20px;">
                  <div class="btn_check_box" style="padding-top: 0; text-align: center;" >
                    <img style="width: 13px; cursor: pointer"
                      src="/static/images/connect2.png"
                      :label="listItem._id" 
                      @click="connectDevice(listItem)">
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!-- // .popup_tel_wrap -->
      </div>
      <!-- //<div class="dataTable> -->
      <div class="btnArea">
        <button class="btn type3 reset" @click="closeDialog">닫기</button>
      </div>
    </div>
  </v-card>
  </v-dialog>
</template>
<script>
import Util from '@/util';
import debounce from 'lodash.debounce';
import moment from 'moment';
export default {
  components: {
  },
  filters: {
    dayConversion: function (time) {
      return moment(time).format('YYYY.MM.DD');
    },
    timeConversion: function (time) {
      return moment(time).format('HH:mm');
    },
  },
  props: [
    'dialog',
    'meetingInfo',
    'closeDialog'
  ],
  data () {
    return {
      loading: true,
      error: null,
      deviceList: []
    };
  },
  watch: {
    dialog: function (newVal) {
      if (newVal === true) {
        this.init();
      }
    }
  },
  mounted () {
    this.loading = false;
  },
  methods: {
    async init () {
      this.error = null;
      this.deviceList = [];
      await this.getInviteDeviceList(this.meetingInfo._id);
    },
    close () {
      this.closeDialog(undefined);
    },
    async getInviteDeviceList (meetingId) {
      await this.$http.get(`/api/v1/meetings/inviteDevices/${meetingId}`).then(response => {
        this.deviceList = response.data;
      }).catch(err => {
        console.log(err);
      });
    },
    connectDevice (deviceInfo) {
      let params = {
        meetingId: this.meetingInfo._id,
        deviceId: deviceInfo._id
      };
      this.$http.post(`/api/v1/meetings/calls/device`, params).then(response => {
        this.deviceList = response.data;
      }).catch(err => {
        console.log(err);
      });
    }
  }
};
</script>
<style scoped>
a {
  color: #464646;
  font-weight: 300;
}
.seltabcontent .seltab{
  width: 9%;
}
.p_ad {
  width: 42%;
  border: 1px solid #989898;
  border-radius: 5px;
  padding: 30px 15px 25px 15px;
  position: relative;
  font-weight: 500;
}

.seltab_r .scroll_tit li {
  float: left;
  height: 23px;
  padding-top: 7px;
  padding-bottom: 3px;
  text-align: center;
  border-top: 2px solid #fa4242;
  border-bottom: 1px solid #fa4242;
}

.checkbox {
  position: relative;
  font-size: 12px;
  float: none;
  padding: 0;
}
.checkbox input[type="checkbox"] {
    display: none;
}
.checkbox input[type="checkbox"]+label:before {
  position: unset;
  border: none;
}

.popContainer .checkbox  input[type="checkbox"] + label { 
  border: 1px solid #7f7f7f;
  display: inline-block; 
  width:12px; 
  height: 12px; 
  background: #fff;
  cursor: pointer; 
  position: unset;
  padding: 0;
}
.popContainer .checkbox :after {display:block; clear:both; content:"";}
.popContainer .checkbox input[type="checkbox"]:checked + label:before {
  position: unset;
  left: 0;
  top: 0;
  background: #fff;
  width: 0;
  height: 0;
  border: none;
}

.popContainer .checkbox input[type="checkbox"]:checked+label:after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 10px;
  height: 10px;
  background: #fa4242;
}

/* 선택목록 스크롤 바 */
.mCustomScrollbar::-webkit-scrollbar {
  width: 6px;
}
.mCustomScrollbar::-webkit-scrollbar-track {
  background-color: transparent;
}
.mCustomScrollbar::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: gray;
}
.mCustomScrollbar::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}
.seltab .btn_com {
  display: inline-block;
  width: 60px;
  height: 30px;
  line-height: 30px;
  padding: 0;
  color: white;
}
.btn_com{
  color: white;
}
.btn_linedf{
color: #fa4242;
}


/* 체크박스 */
.btn_check_box > .container-checkbox {
    display: block;
    position: relative;
    cursor: pointer;
    font-size: 17px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    float: left;
    margin-right: 10px;
    font-size: 17px;
    width: 100%;
}

.btn_check_box > .container-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    width: 50px;
    height: 30px;
    z-index: 100;
    top: -16px;
    right: 0px;
}

.btn_check_box > .container-checkbox .checkmark {
    position: absolute;
    border: 1px solid #7f7f7f;
    display: inline-block;
    width: 15px;
    height: 15px;
    background: #fff;
    cursor: pointer;
    top: -5px;
    right: 18px;
}

/* On mouse-over, add a grey background color */
.btn_check_box > .container-checkbox:hover input ~ .checkmark {
    
}

/* When the checkbox is checked, add a blue background */
.btn_check_box > .container-checkbox input:checked ~ .checkmark {
    background-color: white;
}

/* Create the checkmark/indicator (hidden when not checked) */
.btn_check_box > .container-checkbox .checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.btn_check_box > .container-checkbox input:checked ~ .checkmark:after {
    display: block;
    content: '';
    top: 1px;
    left: 1px;
    width: 11px;
    height: 11px;
    background: #fa4242;
}

/* Style the checkmark/indicator */
.btn_check_box > .container-checkbox .checkmark:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border-width: 0 3px 3px 0;
    
}

.btn_check_box {
  padding-top: 4px;
}

.bookmark-delete-btn{
  float: right;
  border: none;
  border-radius: 5px;
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  width: 80px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}
#bookmarkMeeting .dataTable table td { 
  height: 40px;
  padding-top: 13px;
  padding-bottom: 13px;
}

#bookmarkImage {
  float: left;
  max-width: 160px;
  margin-top: 8px;
}

#bookmarkFixLayout {
  float: left;
  width: 50%;
  margin-top: 0;
  margin-left: 20px;
}

.fix-seat-list{
  font-size: 12pt;
  margin: 0 !important;
}

.activeTarget{
  color: #0d99de;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/DeviceConnectionDialog.vue